import MemberEntity from '../entities/Member';

export type State = MemberEntity[];

const initialState: State = [];

const Member = (state: State = initialState, action: any) => {
  switch (action.type) {
    case 'SUCCESS_READ_MEMBERS_ALL':
      return [...action.members].filter(
        (member, index, self) =>
          self.map(m => m.id).indexOf(member.id) === index
      );

    case 'SUCCESS_READ_MEMBERS_BY_GROUP':
      return [...action.members].filter(
        (member, index, self) =>
          self.map(m => m.id).indexOf(member.id) === index
      );

    case 'SUCCESS_READ_MEMBERS_DIFF':
      return [...state, ...action.members].filter(
        (member, index, self) =>
          self.map(m => m.id).indexOf(member.id) === index
      );

    case 'SUCCESS_UPDATE_MEMBER':
      return state.map(member => {
        return member.id === action.member.id ? action.member : member;
      });

    case 'SUCCESS_DESTROY_MEMBER':
      return state.filter(member => member.id !== action.member.id);
  }

  return state;
};

export default Member;



// WEBPACK FOOTER //
// ./src/reducers/Member.ts